import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'app-select-language',
    templateUrl: './select-language.component.html',
    styleUrls: ['./select-language.component.scss'],
    standalone: false
})
export class SelectLanguageComponent implements OnInit {
  value: any;
  label: any;
  languageArr: any;
  selectedLanguage: any;
  public allCountries: any = [
    {
      "name": "Bahasa",
      "flagUrl": "https://flagcdn.com/w320/id.png",
      "code": "ID"
    },
    {
      "name": "English",
      "flagUrl": "https://flagcdn.com/w320/us.png",
      "code": "EN"
    },
    {
      "name": "Spanish",
      "flagUrl": "https://flagcdn.com/w320/es.png",
      "code": "SP"
    },
    {
      "name": "Russia",
      "flagUrl": "https://flagcdn.com/w320/ru.png",
      "code": "RU"
    }
  ];
  languagewithFlag: any;
  constructor(public modalCtrl: ModalController,
    public platform: Platform,
    public _appService: AppService,
    private navParams: NavParams) { }

  ngOnInit() {

    this.languageArr = JSON.parse(this.navParams.data.languageArr);
    this.languagewithFlag = this.languageArr.map(language => {
      // Find the matching flag in the countryFlags array
      const matchingFlag = this.allCountries.find(flag => flag.code.toLowerCase() === language.code.toLowerCase());

      // Add the flagUrl to the language object if a match is found
      return {
        ...language,
        flagUrl: matchingFlag ? matchingFlag.flagUrl : null
      };
    });
    this.selectedLanguage = this.navParams.data.selectedLanguageId
  }

  closeModal() {
    this.modalCtrl.dismiss({
    });
  }
  getValue() {
    this.modalCtrl.dismiss({
      data: this.value
    });
  }
  selectLanguage(language: any) {
    this.modalCtrl.dismiss({
      selectedlanguage: language
    });

  }

}
